import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useProtectedRoutes = () => {
  return useQuery({
    queryKey: ['pin-protection', 'protected-routes'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('os_pin_protection')
        .select('protected_routes')
        .maybeSingle();

      if (error && error.code !== 'PGRST116') throw error;
      
      return (data?.protected_routes || []) as string[];
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
  });
};
